<template>
  <v-layout>
    <v-app-bar
        app
        dark
        color="secondary"
    >
      <v-btn
          icon
          to="/applications/"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>Application #{{ number }} ({{ option }})</v-toolbar-title>
    </v-app-bar>
    <v-main>
      <application-alert v-if="!isAdmin" :id="id"></application-alert>
      <application-progress-admin
          v-if="isAdmin && progress.length" :id="id" :progress="progress"
          :step="currentStep"
          class="mb-4"
      ></application-progress-admin>
      <application-progress
          v-else :progress="progress" :step="currentStep"
          class="mb-4"
      ></application-progress>
      <v-row>
        <v-col cols="12" md="6" lg="6">
          <application-applicants :id="id"></application-applicants>
          <application-documents :id="id" class="mt-3"></application-documents>
        </v-col>
        <v-col cols="12" md="6" lg="6">
          <application-messages :id="id" ref="messages" :online="socketOnline"></application-messages>
          <application-courier-history :id="id" class="mt-3"></application-courier-history>
        </v-col>
      </v-row>
      <v-row v-if="isAdmin">
        <v-col cols="12" lg="6" md="6">
          <application-actions-admin :id="id"/>
        </v-col>
      </v-row>
      <v-row v-if="isAdmin">
        <v-col cols="12">
          <application-alert-admin :id="id"></application-alert-admin>
        </v-col>
      </v-row>
    </v-main>
  </v-layout>
</template>
<script>
import {mapGetters} from 'vuex'

import ApplicationApplicants from './Applicants/index'
import ApplicationDocuments from './Documents/index'
import ApplicationProgress from './Progress/index'
import ApplicationProgressAdmin from './Progress/Admin'
import ApplicationMessages from './Messages/index'
import ApplicationCourierHistory from './CourierHistory/index'
import ApplicationAlert from './Alerts/index'
import ApplicationAlertAdmin from './Alerts/Admin'
import ApplicationActionsAdmin from "@/components/Applications/Actions/Admin";
import {errorNotification} from "@/components/utils";

export default {
  components: {
    ApplicationActionsAdmin,
    ApplicationCourierHistory,
    ApplicationMessages,
    ApplicationDocuments,
    ApplicationApplicants,
    ApplicationProgress,
    ApplicationProgressAdmin,
    ApplicationAlert,
    ApplicationAlertAdmin
  },
  name: 'ApplicationView',
  data() {
    return {
      id: Number(this.$route.params.id),
      number: '',
      option: '',
      currentStep: 0,
      progress: [],
      socket: false,
      socketOnline: false,
      socketConnectAttempts: 0
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isAdmin'
    ])
  },
  methods: {
    fetchData() {
      this.$axios.get('/applications/' + this.id + '/', {})
          .then((response) => {
            this.number = response.data.number
            this.progress = response.data.progress
            this.option = response.data.option_name
            this.currentStep = response.data.current_step
          })
          .catch((error) => {
            if (error.response.status == 404) {
              this.$router.push('/applications/')
            }
            errorNotification(error)
          })
    },
    createSocket() {
      // TODO: Change it to Cookie based auth
      this.socketOnline = false
      if (this.socketConnectAttempts < 10) {
        this.socket = new WebSocket(
            `${process.env.VUE_APP_WS_URL}/ws/applications/${this.id}/?token=${this.$store.getters['auth/token']}`
        )
        this.socket.addEventListener('message', this.socketMessageListener);
        this.socket.addEventListener('open', () => {
          this.socketOnline = true
        });
        this.socket.addEventListener('close', this.createSocket);
      }
    },
    socketMessageListener(event) {
      const messages = this.$refs.messages
      const data = JSON.parse(event.data)
      if (data.type === 'send_message') {
        messages.push(data.message)
      }
    }
  },
  mounted() {
    this.fetchData()
    this.createSocket()
  },
  beforeRouteLeave(to, from, next) {
    // Close websocket to application channel
    if (this.socket !== null && this.socket.readyState === 1) {
      this.socket.removeEventListener('close', this.createSocket)
      this.socket.close()
    }
    next()
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.v-main {
  padding-top: 72px !important;
}
</style>